import { Button } from "@/components/ui/button";
import { ArrowRight, Info } from "lucide-react";
import type { PageView } from "@/types/maturity";

type ResumeBannerProps = {
  checkedCount: number;
  onNavigate: (view: PageView) => void;
};

function ResumeBanner({ checkedCount, onNavigate }: ResumeBannerProps) {
  return (
    <div className="flex items-center justify-between gap-4 p-4 rounded-xl bg-blue-50 border border-blue-200">
      <div className="flex items-center gap-3">
        <Info className="w-5 h-5 text-blue-500 shrink-0" />
        <span className="text-sm text-blue-800">
          Ai {checkedCount} elemente bifate în evaluarea preliminară.
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="gap-1 shrink-0"
        onClick={() => onNavigate("preliminary")}
      >
        Continuă
        <ArrowRight className="w-3 h-3" />
      </Button>
    </div>
  );
}

export default ResumeBanner;
